import { isBrowser } from '../isBrowser';

const useSmallDevice = () => {
	const isSmallDevice = isBrowser()
		? window.matchMedia('(max-width: 576px)')
		: null;

	return isSmallDevice && isSmallDevice.matches;
};

export default useSmallDevice;
